import axios from 'axios'
import { getUiServicesEndpoint } from './utils'

interface MaxCapacityApiResponse {
  vendor_id: number
  location: {
    id: string
    max_outbound_trailers: number
  }
  pickup_date: string
  number_of_scheduled_loads: number
  is_location_over_capacity?: boolean
}

export const getLocationCapacityEndpoint = async (
  locationId: string,
  vendorId: number,
  pickupDate: string,
): Promise<string> => {
  const { key, url } = await getUiServicesEndpoint()
  return `${url}/v1/locations/capacity?vmm_location_id=${locationId}&vendor_id=${vendorId}&pickup_date=${pickupDate}&key=${key}`
}

export const fetchLocationCapacity = async (
  locationId: string | undefined,
  vendorId: number | undefined,
  pickupDate: string | undefined,
): Promise<MaxCapacityApiResponse> => {
  if (locationId && vendorId && pickupDate) {
    const url: string = await getLocationCapacityEndpoint(
      locationId,
      vendorId,
      pickupDate,
    )
    return axios.get<MaxCapacityApiResponse>(url).then((res) => {
      return res.data
    })
  }
  return Promise.reject('Invalid parameters for fetchLocationCapacity')
}
